import {
  requireCoachLicense,
} from "./safeGuards";

import AddClients from "@/pages/coaches/clientOnboarding/addClients";
import ClientOnboarding from "@/pages/coaches/clientOnboarding";
import HabitProgramList from "@/pages/coaches/habitProgram";
import HabitProgram from "@/pages/coaches/habitProgram/detail";
import HabitProgramNew from "@/pages/coaches/habitProgram/new";
import NewCourse from "@/pages/coaches/courses/new";
import CoachCourses from "@/pages/coaches/courses";
import CoachCourseDetail from "@/pages/coaches/courses/detail";
import NewModule from "@/pages/coaches/courses/modules/new";
import EditModule from "@/pages/coaches/courses/modules/edit";
import Cohorts from "@/pages/coaches/cohorts";
import NewCohort from "@/pages/coaches/cohorts/new";
import EditCohort from "@/pages/coaches/cohorts/edit";
import CohortDetail from "@/pages/coaches/cohorts/detail";
import GettingStarted from "@/pages/gettingStarted";
import PulseSurveys from "@/pages/coaches/pulseSurveys";
import PulseSurveyDetail from "@/pages/coaches/pulseSurveys/detail";
import PulseSurveyPreview from "@/pages/coaches/pulseSurveys/detail/preview";
import NewPulseSurvey from "@/pages/coaches/pulseSurveys/new";
import Messages from "@/pages/coaches/messages";
import Dashboard from "@/pages/coaches/dashboard";
import coachAssessments from "@/pages/coaches/assessments";
import assessmentLibrary from "@/pages/coaches/assessments/library";
import assessmentDistribute from "@/pages/coaches/assessments/distribute";
import coachAssessmentResults from "@/pages/coaches/assessments/results";
import coachAssessmentCustomCreation from "@/pages/coaches/assessments/createCustomAssessment";
import adminSettings from "@/pages/admin/settings";
import automatedReg from "@/pages/coaches/clientOnboarding/automatedReg";
import clientDetail from "@/pages/coaches/clientDetail";
import clientSettings from "@/pages/coaches/clientDetail/settings";
import clientGoals from "@/pages/coaches/clientDetail/goals";
import clientPulse from "@/pages/coaches/clientDetail/pulse";
import clientReflections from "@/pages/coaches/clientDetail/reflections";
import clientCourseHistory from "@/pages/coaches/clientDetail/courseHistory";
import clientHabits from "@/pages/coaches/clientDetail/clientHabits";
import completeLinkWithStripe from "@/pages/admin/completeLinkWithStripe"


const routes = [
  requireCoachLicense("/dashboard", Dashboard, "dashboard"),
  requireCoachLicense("/add-clients", AddClients, "addClients", {meta: "hello"}),
  requireCoachLicense("/automated-registration", automatedReg, "automatedReg"),
  requireCoachLicense("/pulse-surveys", PulseSurveys),
  requireCoachLicense("/pulse-surveys-new", NewPulseSurvey, "newPulseSurvey"),
  requireCoachLicense(
    "/pulse-surveys/:id",
    PulseSurveyDetail,
    "pulseSurveyDetail"
  ),
  requireCoachLicense(
    "/pulse-surveys/:id/preview",
    PulseSurveyPreview,
    "pulseSurveyPreview"
  ),
  requireCoachLicense(
    "/habit-programs",
    HabitProgramList,
    "HabitProgramList"
  ),
  requireCoachLicense(
    "/habit-programs/new",
    HabitProgramNew,
    "newHabitProgram"
  ),
  requireCoachLicense(
    "/habit-programs/:id",
    HabitProgram,
    "themesDetail",
    true
  ),
  requireCoachLicense(
    "/coach/assessment/creation", coachAssessmentCustomCreation, "coachAssessmentCreation"
  ),
  requireCoachLicense(
    "/coach/assessment-library", assessmentLibrary, "coachAssessmentLibrary"
  ),
  requireCoachLicense(
    "/coach/assessment-distribute", assessmentDistribute, "coachAssessmentDistribute"
  ),
  requireCoachLicense(
    "/coach/assessments",
    coachAssessments,
    "coachAssessments"
  ),
  requireCoachLicense(
    "/coach/assessments/:id",
    coachAssessmentResults,
    "coachAssessmentResults"
  ),
  requireCoachLicense("/courses/new", NewCourse, "newCourse"),
  requireCoachLicense("/coach-courses", CoachCourses, "coach-courses"),
  requireCoachLicense(
    "/coach-courses/:id",
    CoachCourseDetail,
    "CoachCourseDetail",
    true
  ),
  requireCoachLicense( "/courses/:course_id/modules/new", NewModule, "newModule", true),
  requireCoachLicense("/courses/modules/:id", EditModule, "editModule", true),
  requireCoachLicense("/client-onboarding", ClientOnboarding, "clientOnboarding"),
  requireCoachLicense("/cohorts", Cohorts),
  requireCoachLicense("/cohorts/new", NewCohort),
  requireCoachLicense("/cohorts/edit/:id", EditCohort),
  requireCoachLicense("/cohorts/:id", CohortDetail, "cohortDetail"),
  requireCoachLicense("/getting-started", GettingStarted, "gettingStarted"),
  requireCoachLicense("/messages", Messages, "messages"),
  requireCoachLicense(
    "/site-management/settings",
    adminSettings,
    "siteSettings"
  ),
  requireCoachLicense("/complete-link-with-stripe", completeLinkWithStripe),

  { path: "/client-detail/:id", component: clientDetail, children: [
    {
      path: "goals",
      component: clientGoals,
      name: "clientGoals"
    },
    {
      path: "pulse",
      component: clientPulse,
      name: "clientPulse"
    },
    {
      path: "reflections",
      component: clientReflections,
      name: "clientReflections"
    },
    {
      path: "courses",
      component: clientCourseHistory,
    },
    {
      path: "habits",
      component: clientHabits
    }, 
    {
      path: "settings",
      component: clientSettings,
      name: "clientSettings"
    }
  ]}
];

export default routes;